import React from "react";
import BaseCard from "../../../components/ui/BaseCard";
import { useParams } from "react-router-dom";
import MuiAccordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { styled } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { fetchUserWorkSummary } from "../../../services/api/user";
import dayjs from "dayjs";

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  "&.Mui-expanded": {
    margin: "0px !important",
  },

  "&.Mui-expanded .MuiAccordionSummary-root": {
    backgroundColor: "#f6f6f6",
    border: "none !important",
    borderRadius: "8px",
  },
  "&.Mui-expanded .MuiAccordionSummary-root h6": {
    color: "#fff !important",
  },
}));

const WorkSummary = () => {
  const { id: userId } = useParams();
  const {
    data: workSummaryData,
    isPending: isFetchWorkSummaryApiLoading,
    error: isFetchWorkSummaryApiError,
  } = useQuery({
    queryKey: ["workSummary", userId],
    queryFn: () => fetchUserWorkSummary(userId),
    enabled: !!userId,
  });

  return (
    <BaseCard className="py-2 px-8 sm:px-10 rounded-lg" elevation={1}>
      <div className="bg-light -mx-4 px-4 py-2 mt-2 mb-4 rounded-md flex justify-between items-center">
        <h6 className="text-dark font-normal">Work Summary</h6>
      </div>

      {workSummaryData?.data?.map((category, index) => (
        <Accordion key={index} className="mb-4">
          <AccordionSummary
            className="bg-light rounded-md"
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <div className="flex items-center justify-between w-full">
              <p className="text-base font-normal ">{category?.category}</p>
              <p className="text-primary font-medium">
                {category.totalJobs > 1
                  ? `${category.totalJobs} Jobs`
                  : `${category.totalJobs} Job`}
              </p>
            </div>
          </AccordionSummary>
          <AccordionDetails className="bg-white mb-4 bg-white shadow rounded-md">
            <div>
              {category?.services?.map((service, index) => (
                <div className="lg:flex justify-between lg:mt-2 mt-4" key={index}>
                  <div className="flex items-center">
                    <p className="text-sm font-normal w-[200px]">{service?.subCategory}</p>
                    <div className="flex items-center mr-2">
                      <i className="fa-solid fa-star text-sm text-[#e5e5e5] mr-1"></i>
                      <p>N/A</p>
                    </div>
                    <div className="flex items-center mr-2">
                      <i className="fa-solid fa-star text-sm text-[#e5e5e5] mr-1"></i>
                      <p>N/A</p>
                    </div>
                  </div>
                  <p className="lg:mt-0 mt-2">
                    <span className="text-primary">{service?.jobs} Job</span> Last completed about{" "}
                    {dayjs(service?.lastCompletedJob).fromNow()}
                  </p>
                </div>
              ))}
            </div>
          </AccordionDetails>
        </Accordion>
      ))}
    </BaseCard>
  );
};

export default WorkSummary;
